import { AppServiceApi } from 'my-recruiter-app-ts-if'
import { config } from './api-config'

export const appServiceApi = new AppServiceApi(config)
